import { Paper, Skeleton, Stack } from '@mantine/core';

type PerformanceCardSkeletonProps = {
  chartHeight?: number;
};

export function PerformanceCardSkeleton({ chartHeight = 220 }: PerformanceCardSkeletonProps) {
  return (
    <Paper withBorder radius="md" p="md">
      <Stack spacing="sm">
        <Skeleton height={16} width="45%" radius="sm" />
        <Skeleton height={12} width="30%" radius="sm" />
        <Skeleton height={44} radius="sm" />
        <Skeleton height={chartHeight} radius="sm" />
      </Stack>
    </Paper>
  );
}
